import DG_Form from "../../../../custom/data-entry/form";
import React, {useEffect, useState} from "react";
import {Col, Collapse, Form, Input, InputNumber, message, Row, Select, Tag, Tooltip} from "antd";
import {t} from "i18next";
import {
    deleteStandardWorkday,
    deleteTimesheetFormula,
    getTimekeepingFormula,
    postTimekeepingFormula
} from "../../../../api/setting/timekeeping/timekeeping-formula/api";
import dayjs from "dayjs";
import ConfigSelectTable, {genderNameSearch} from "./ConfigSelectTable";
import ConfigSelectChange from "./ConfigSelectChange";
import {CloseOutlined, PlusCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {ConfigKeyword} from "./ConfigKeyword";
import DG_Button from "../../../../common/button/Button";
import DG_Cancel from "../../../../common/button/Cancel";
import DG_Submit from "../../../../common/button/Submit";
import {Calculation} from "../../../hrm/wage/salaryconfig/Add";
import FilterTimeSheet from "./FilterTimeSheet";
import DG_DatePicker from "../../../../custom/date-picker";
import {usedGraphqlLazyQuery} from "../../../../custom/graphql/graphql-client";
import {useLazyQuery} from "@apollo/client";
import {GET_FORMULA_BY_TYPES} from "../../../../api/setting/timekeeping/timekeeping-formula/apiGql";
import ConfigSelectCalculation from "./ConfigSelectCalculation";
import { GrTooltip } from "react-icons/gr";
import InputDecimal from "../../../../custom/data-entry/input-number/InputDecimal";
import {formatCurrency, unFormatCurrency} from "../../../../format/Money";
const { TextArea } = Input;
const TimesheetFormula = (props) => {

    const {Panel} = Collapse;
    const [form] = Form.useForm();
    const {Option} = Select;

    const [changeMonth, setChangeMonth] = useState([]);
    const [change, setChange] = useState([]);
    const [deleteTimesheetValue, setDeleteTimesheetValue] = useState([]);
    const [deleteStandardValue, setDeleteStandardValue] = useState([]);
    const [timesheetLength, setTimesheetLength] = useState(1);
    const [standardLength, setStandardLength] = useState(1);
    const dateFormat = 'MM/YYYY';
    const [SHIFT_KEYWORD1, setSHIFT_KEYWORD1] = useState([]);
    const [DATE_KEYWORD1, setDATE_KEYWORD1] = useState([]);
    const [OVERTIME_KEYWORD1, setOVERTIME_KEYWORD1] = useState([]);
    const [MONTHLY_APPLICATION_KEYWORD1, setMONTHLY_APPLICATION_KEYWORD1] = useState([]);
    const [loading, setLoading] = useState(false)
    const [dataSummary, setDataSummary] = useState([])
    const [getFormulaKeyword] = useLazyQuery(GET_FORMULA_BY_TYPES)
    const standardWorkdayUseWatch =Form.useWatch('standardWorkdays', form);

    function loadData() {
        setLoading(true)

        getTimekeepingFormula().then((res) => {

            let timesheet = []
            let standard = []
            let changeTemp  = []
            let changeMonthTemp  = []

            res.timeSheetFormulas.forEach((item, index) => {
                timesheet.push({
                    id: item.id,
                    table: item.table === "" ? undefined : item.table,
                    change: item.change === "" ? undefined : item.change,
                    columnCell: item?.columnCell === "" ? undefined : (item?.keyword !== undefined && item.change === "FORMULA" ) ? t("layout.keyword." + item.keyword) : item.columnCell,
                    keyword: item.keyword === "" ? undefined : item.keyword,
                    formulaValue: item.formulaValue === "" ? undefined : item.formulaValue,
                    result: item.result === "" ? undefined : item.result,
                    description: item.description === "" ? undefined : item.description
                })

                if (item.change === "FORMULA") {
                    if (!changeTemp.includes(index)) {
                        (changeTemp.push(index))
                    }
                }

                if (item.table === "MONTH") {
                    if (!changeMonthTemp.includes(index)) {
                      changeMonthTemp.push(index)
                    }
                }
            })
            res.standardWorkdays.forEach((item) => {
                standard.push({
                    id: item.id,
                    calculation: item.calculation === "" ? undefined : item.calculation,
                    value: formatCurrency(item.value),
                    departmentIds: item.departmentIds === "" ? undefined : item.departmentIds,
                    jobPositionIds: item.jobPositionIds === "" ? undefined : item.jobPositionIds
                })
            })
            res = {
                ...res,
                date: dayjs(res.date),
                timeSheetFormulas: timesheet,
                standardWorkdays: standard?.length === 0 ? [{
                    calculation: "SUB_SATURDAY"
                }] : standard
            }
            form.setFieldsValue(res)
            setTimesheetLength(res.timeSheetFormulas.length)
            setStandardLength(res.standardWorkdays.length)
            setChange(changeTemp)
            setChangeMonth(changeMonthTemp)
        }).finally(() => setLoading(false))
    }

    useEffect(() => {
     const fetchDataFormulaKeyword = async () => {
         const [
             shiftRes,
             dateRes,
             overtimeRes,
             monthlyApplicationRes
         ] = await Promise.all([
             usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.SHIFT_KEYWORD}),
             usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.DATE_KEYWORD}),
             usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.OVERTIME_KEYWORD}),
             usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.MONTHLY_APPLICATION_KEYWORD}),
         ])

         setSHIFT_KEYWORD1(shiftRes?.data?.formulaKeyword?.items || [])
         setDATE_KEYWORD1(dateRes?.data?.formulaKeyword?.items || [])
         setOVERTIME_KEYWORD1(overtimeRes?.data?.formulaKeyword?.items || [])
         setMONTHLY_APPLICATION_KEYWORD1(monthlyApplicationRes?.data?.formulaKeyword?.items || [])
     }

        fetchDataFormulaKeyword().then(r => {
            loadData()
        })
    }, [])

    useEffect(() => {
      const mapDataSource = props.dataConfig?.map(item => {
          switch (item.type) {
              case ConfigKeyword.SHIFT_KEYWORD :
                  return {
                      ...item,
                      column : `CA!${item.column}`
                  }
              case ConfigKeyword.DATE_KEYWORD :
                  return {
                      ...item,
                      column : `NGAY!${item.column}`
                  }
              case ConfigKeyword.OVERTIME_KEYWORD :
                  return {
                      ...item,
                      column : `THEM!${item.column}`
                  }

              case ConfigKeyword.MONTHLY_APPLICATION_KEYWORD :
                    return {
                        ...item,
                        column : `THANG!${item.column}`
                    }

          }
      })
       setDataSummary(mapDataSource)
    }, [props]);

    const deleteTimesheet = (index) => {

        const {timeSheetFormulas} = form.getFieldsValue()
        if (timeSheetFormulas[index]) {
            setDeleteTimesheetValue(deleteTimesheetValue.concat(timeSheetFormulas[index].id))
        }
        setTimesheetLength(timesheetLength - 1);
    }

    const addTimesheet = () => {
        setTimesheetLength(timesheetLength + 1);
    }

    const deleteStandard = (index) => {
        setStandardLength(standardLength - 1);
        const {standardWorkdays} = form.getFieldsValue()
        if (standardWorkdays[index]) {
            setDeleteStandardValue(deleteStandardValue.concat(standardWorkdays[index].id))
        }
    }

    const addStandard = () => {
        setStandardLength(standardLength + 1);
    }

    const handleSelectTable = (value, index) => {
        if (value === "MONTH") {
            if (!changeMonth.includes(index)) {
                setChangeMonth(changeMonth.concat(index))
            }
        } else {
            setChangeMonth(changeMonth.filter(item => item !== index))
        }

        if (value === undefined) {
            setChangeMonth(changeMonth.filter(item => item !== index))
        }

    }

    const handleSelectChange = (value, index) => {

        if (value === "FORMULA") {
            if (!change.includes(index)) {
                setChange(change.concat(index))
            }
        } else {
            setChange(change.filter(item => item !== index))
        }

        if (value === undefined) {
            setChange(change.filter(item => item !== index))
        }

        const {timeSheetFormulas} = form.getFieldsValue()

        if (value === undefined) {
            Object.assign(timeSheetFormulas[index], {
                keyword: undefined,
                columnCell: undefined,
            })
            form.setFieldsValue({timeSheetFormulas})
        }
    }

    const handleSelectColumnCell = (value, index,label ) => {
        const {timeSheetFormulas} = form.getFieldsValue()
        if (value !== undefined) {

            timeSheetFormulas.forEach((item) => {

                if (item.columnCell === value) {
                    Object.assign(timeSheetFormulas[index], {
                        keyword: label?.key ,
                    })
                    form.setFieldsValue({timeSheetFormulas})
                }
            })
        } else {
            Object.assign(timeSheetFormulas[index], {
                keyword: undefined,
                columnCell: undefined,
            })
            form.setFieldsValue({timeSheetFormulas})
        }
    }

    const check = (standardWorkdays, error) => {

        if (!standardWorkdays) return true;
        if (standardWorkdays.length === 0) return true;

        let check = true;
        standardWorkdays.forEach((item) => {

            if ((item.value < 0 || !item.value) && (standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "OTHER" ||
                standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "SUB_HALF_N_DAY")) {
                check = false
            }
        })

        if (!check) {
            if (error) message.error(error)
        }

        return check;
    }

    const onFinish = (values) => {

        check(values.standardWorkdays, t("actionFormula.error"))

        if (check(values.standardWorkdays)) {

            values["standardWorkdays"] = values?.standardWorkdays?.map(item => {
                return {
                    ...item,
                    value : unFormatCurrency(item.value)
                }
            })

            setLoading(true)
            deleteTimesheetValue.forEach((item) => {
                deleteTimesheetFormula(item).then(r => {
                });
            })
            deleteStandardValue.forEach((item) => {
                deleteStandardWorkday(item).then(r => {
                });
            })
            setDeleteStandardValue([])
            setDeleteTimesheetValue([])
            postTimekeepingFormula(values).then((res) => {
                message.success(t("tnp.button.messageUpdate")).then(() => {})
                loadData()
            }).finally(() => setLoading(false));
        }
    }

    const filterOption = (input, option) => {
        const normalizedInput = input?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
        const normalizedOption = option?.dataSearch.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");

        return normalizedOption.includes(normalizedInput);
    };

    const tProps = {
        treeCheckable: true,
        style: {
            width: "100%"
        }
    };

    function getOptionValue(change) {

        switch(change){
            case "MONTH" :
            return MONTHLY_APPLICATION_KEYWORD1
            case "DATE" :
              return DATE_KEYWORD1
            case "SHIFT" :
             return SHIFT_KEYWORD1
            case "OVERTIME" :
               return OVERTIME_KEYWORD1
            case "MEETING" :
            case "MISSION" :
            case "CHECKIN/OUT" :
            return []
        }
        return [];
    }

    return (
        <>
            <DG_Form
                name="nest-messages"
                onFinish={onFinish}
                layout="vertical"
                form={form}
                scrollToFirstError
                mode={'update'}
                style={{
                    background: "#fff",
                    borderRight: "1px solid #EAECF0",
                    borderLeft: "1px solid #EAECF0",
                    borderTop: "1px solid #EAECF0",
                    height: "100%",
                    position: 'relative'
                }}
            >
                <DG_Button title={<FilterTimeSheet title={t("tnp.components.timekeeping.text55")}/>} isHasScroll={true}>
                    <DG_Cancel/>
                    <DG_Submit loading={props?.loading || loading}/>
                </DG_Button>
                <div
                    style={{
                        width: '100%',
                        overflowY: "auto",
                        overflowX: "auto",
                        height: "calc(90vh - 110px)",
                        padding: "10px 20px",
                        position: "relative",
                        right: 0,
                        background: "#fff",
                        left: 0
                    }}
                >
                    <Form.Item>
                        <Collapse defaultActiveKey={['1']} ghost>
                            <Panel header={t("formulaTitle.timekeepingFormula")} key="1">
                                {
                                    timesheetLength > 0 ?
                                        (<Row gutter={12}>

                                            <Col xxl={{span: 3}}
                                                 xl={{span: 3}}
                                                 lg={{span: 3}}>

                                                <label> {t("formulaTitle.table")} <span className={"text-red-600"}> *</span></label>
                                            </Col>
                                            <Col xxl={{span: 3}}
                                                 xl={{span: 3}}
                                                 lg={{span: 3}}>

                                                <label> {t("formulaTitle.change")} <span className={"text-red-600"}> *</span></label>
                                            </Col>
                                            <Col xxl={{span: 3}}
                                                 xl={{span: 3}}
                                                 lg={{span: 3}}>

                                                <label> {t("formulaTitle.nameCell")} <span className={"text-red-600"}> *</span></label>
                                            </Col>
                                            <Col xxl={{span: 3}}
                                                 xl={{span: 3}}
                                                 lg={{span: 3}}>

                                                <label> {t("formulaTitle.keyword")} <span className={"text-red-600"}> *</span></label>
                                            </Col>
                                            <Col xxl={{span: 5}}
                                                 xl={{span: 5}}
                                                 lg={{span: 5}}>
                                                <label className={"pr-1"}>{t("formulaTitle.formula")}</label>
                                                <Tooltip title={<div>
                                                    <b>{t("formulaPlaceholder.informationNote0")}</b>
                                                    <br/>
                                                    <div>{t("formulaPlaceholder.informationNote1")} </div>
                                                    <div>{t("formulaPlaceholder.informationNote2")}</div>
                                                    <div><Tag
                                                        color="red">{t("formulaPlaceholder.informationNote3")}</Tag>
                                                    </div>
                                                    <div>{t("formulaPlaceholder.informationNote4")}</div>
                                                    <div><b>THANG:</b> {t("formulaPlaceholder.informationNote5")}</div>
                                                    <div><b>CA:</b> {t("formulaPlaceholder.informationNote6")}</div>
                                                    <div><b>NGAY:</b> {t("formulaPlaceholder.informationNote7")}</div>
                                                    <div><b>THEM:</b> {t("formulaPlaceholder.informationNote8")}
                                                    </div>
                                                    <div><b>CONG_TAC:</b> {t("formulaPlaceholder.informationNote9")}
                                                    </div>
                                                    <div><b>VANG_MAT:</b> {t("formulaPlaceholder.informationNote10")}
                                                    </div>
                                                    <div>{t("formulaPlaceholder.informationNote11")}</div>
                                                    <div><Tag
                                                        color={"red"}> {t("formulaPlaceholder.informationNote12")} </Tag>
                                                    </div>
                                                    <div>{t("formulaPlaceholder.informationNote13")}</div>
                                                </div>}>
                                                    <QuestionCircleOutlined style={{color: '#B4B6B5'}}/>
                                                </Tooltip>
                                                <span className={"text-red-600"}> *</span>
                                            </Col>
                                            <Col xxl={{span: 2}}
                                                 xl={{span: 2}}
                                                 lg={{span: 2}}>

                                                <label>{t("formulaTitle.result")}</label>
                                            </Col>
                                            <Col xxl={{span: 4}}
                                                 xl={{span: 4}}
                                                 lg={{span: 4}}>

                                                <label> {t("formulaTitle.description")}</label>
                                            </Col>

                                        </Row>) : <></>
                                }

                                <Form.List name="timeSheetFormulas" initialValue={['']}>
                                    {(fields, {add, remove}) => (
                                        <>
                                            {fields.map(field => (
                                                <Row gutter={12}>
                                                    <Col
                                                        xxl={{span: 3}}
                                                        xl={{span: 3}}
                                                        lg={{span: 3}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "table"]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t("formulaTitle.tableRequire"),
                                                                },

                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder={t("formulaPlaceholder.table")}
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={filterOption}
                                                                allowClear
                                                                onChange={(e) => handleSelectTable(e, field.name)}
                                                                popupMatchSelectWidth={300}
                                                            >
                                                                {ConfigSelectTable.map((item) => (
                                                                    <Option value={item.id}
                                                                            dataSearch={genderNameSearch(item?.id)}>{item.type}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 3}}
                                                        xl={{span: 3}}
                                                        lg={{span: 3}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "change"]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t("formulaTitle.changeRequire"),
                                                                },

                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder={t("formulaPlaceholder.change")}
                                                                allowClear
                                                                onChange={(e) => handleSelectChange(e, field.name)}
                                                                popupMatchSelectWidth={200}
                                                            >
                                                                {
                                                                    changeMonth.includes(field.name) ? (
                                                                        ConfigSelectChange.map((item) => (
                                                                            <Option value={item.id}
                                                                                    disabled={item.id === "COLUMN_NEW"}>{item.type}</Option>
                                                                        ))) : (
                                                                        ConfigSelectChange.map((item) => (
                                                                            <Option value={item.id}
                                                                                    disabled={item.id === "ROW_NEW"}>{item.type}</Option>
                                                                        )))
                                                                }
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 3}}
                                                        xl={{span: 3}}
                                                        lg={{span: 3}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "columnCell"]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t("formulaTitle.column_cell"),
                                                                },

                                                            ]}
                                                        >
                                                            {
                                                                change.includes(field.name) ? (
                                                                    <Select
                                                                        placeholder={t("formulaPlaceholder.cellColumn")}
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={filterOption}
                                                                        allowClear
                                                                        onChange={(e,f) => handleSelectColumnCell(e, field.name,f)}
                                                                        popupMatchSelectWidth={300}
                                                                    >
                                                                        {
                                                                            // cell?.filter(
                                                                            //     (item) =>
                                                                            //         item.customFormula === true
                                                                            // )?.map((item) => (
                                                                            //     <Option key={item.column}
                                                                            //             value={item.name}
                                                                            //             dataSearch={item.name}>{item.name}</Option>
                                                                            // ))

                                                                            form.getFieldsValue()?.timeSheetFormulas &&
                                                                            form.getFieldsValue()?.timeSheetFormulas[field.name] &&
                                                                            form.getFieldsValue()?.timeSheetFormulas[field.name]?.table &&

                                                                           getOptionValue(form.getFieldsValue()?.timeSheetFormulas[field.name]?.table)
                                                                               ?.filter(
                                                                                (item) =>
                                                                                    item.customFormula === true
                                                                            )?.map((item) => (
                                                                                <Option key={item.column}
                                                                                        value={item.name}
                                                                                        dataSearch={item.name}>{item.name}</Option>
                                                                            ))


                                                                        }
                                                                    </Select>
                                                                ) : <Input
                                                                    placeholder={t("formulaPlaceholder.cellColumn")}/>
                                                            }
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 3}}
                                                        xl={{span: 3}}
                                                        lg={{span: 3}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "keyword"]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t("formulaTitle.keywordRequire"),
                                                                },

                                                            ]}
                                                        >
                                                            {
                                                                change.includes(field.name) ? (
                                                                    <Input
                                                                        placeholder={t("formulaPlaceholder.keyword")}
                                                                        disabled
                                                                    />) : (
                                                                    <Input
                                                                        placeholder={t("formulaPlaceholder.keyword")}
                                                                    />)
                                                            }
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 5}}
                                                        xl={{span: 5}}
                                                        lg={{span: 5}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "formulaValue"]}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: t("formulaTitle.formulaValueRequire"),
                                                                },

                                                            ]}
                                                        >

                                                            {dataSummary?.length > 0 ?
                                                                <Calculation
                                                                    dataKeyWord={dataSummary}/>
                                                                :
                                                                <Input
                                                                    placeholder={t("formulaPlaceholder.valueFormula")}
                                                                />
                                                            }

                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 2}}
                                                        xl={{span: 2}}
                                                        lg={{span: 2}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "result"]}
                                                        >
                                                            <Select
                                                                placeholder={t("formulaPlaceholder.result")}
                                                                allowClear
                                                                disabled={!changeMonth.includes(field.name)}
                                                                popupMatchSelectWidth={200}
                                                            >
                                                                <Option
                                                                    value={"number"}>{t("typeArray.number")}</Option>
                                                                <Option value={"text"}>{t("typeArray.text")}</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col
                                                        xxl={{span: 4}}
                                                        xl={{span: 4}}
                                                        lg={{span: 4}}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            name={[field.name, "description"]}
                                                        >
                                                            <Input
                                                                placeholder={t("formulaPlaceholder.description")}
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xxl={{span: 1}} xl={{span: 1}}
                                                         lg={{span: 1}}>
                                                        <CloseOutlined
                                                            style={{marginTop: 8}}
                                                            onClick={() => {
                                                                deleteTimesheet(field.name)
                                                                remove(field.name)
                                                            }}/>
                                                    </Col>

                                                </Row>
                                            ))}

                                            <Form.Item>
                                                <PlusCircleOutlined
                                                    onClick={() => {
                                                        addTimesheet()
                                                        add()
                                                    }}
                                                    style={{fontSize: 25}}/>
                                            </Form.Item>
                                        </>
                                    )}

                                </Form.List>
                            </Panel>
                        </Collapse>
                    </Form.Item>

                    <Form.Item>
                        <Collapse defaultActiveKey={['2']} ghost>
                            <Panel header={
                               t("formulaTitle.standardWorkday")

                            } key="2">

                                {
                                    standardLength > 0 ?
                                        (<Row gutter={12} className ="mb-2">

                                            <Col xxl={{span: 8}}
                                                 xl={{span: 8}}
                                                 lg={{span: 8}}>

                                                <label> {t("formulaTitle.calculation")}
                                                    <Tooltip title={t("formulaTitle.calculationToolTip")}>
                                                        <GrTooltip className ="ml-1 cursor-pointer" />
                                                    </Tooltip>
                                                    <span
                                                    style={{color: "red"}}> * </span>
                                                </label>
                                            </Col>
                                            {standardWorkdayUseWatch  &&
                                                (standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "OTHER" ||
                                                    standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "SUB_HALF_N_DAY") && <Col xxl={{span: 3}}
                                                  xl={{span: 3}}
                                                  lg={{span: 3}}>

                                                <label>  { t("formulaTitle.value")}<span
                                                    style={{color: "red"}}> * </span>
                                                </label>
                                            </Col>}
                                            {/*<Col xxl={{span: 6}}*/}
                                            {/*     xl={{span: 6}}*/}
                                            {/*     lg={{span: 6}}>*/}

                                            {/*    <label> {t("formulaTitle.department")}</label>*/}
                                            {/*</Col>*/}
                                            {/*<Col xxl={{span: 7}}*/}
                                            {/*     xl={{span: 7}}*/}
                                            {/*     lg={{span: 7}}>*/}

                                            {/*    <label> {t("formulaTitle.jobPosition")}</label>*/}
                                            {/*</Col>*/}

                                        </Row>) : <></>
                                }

                                <Form.List name={"standardWorkdays"} initialValue={['']}>
                                    {
                                        (fields, {add, remove}) => (
                                            <>
                                                {
                                                    fields.map(field => (
                                                        <Row gutter={12}>
                                                            <Col
                                                                xxl={{span: 8}}
                                                                xl={{span: 8}}
                                                                lg={{span: 8}}
                                                            >
                                                                <Form.Item
                                                                    {...field}
                                                                    name={[field.name, "calculation"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: t("formulaTitle.calculationRequire")
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder={t("formulaPlaceholder.calculation")}
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={filterOption}
                                                                        popupMatchSelectWidth={450}
                                                                    >
                                                                        {ConfigSelectCalculation.map((item) => (
                                                                            <Option value={item.id}
                                                                                    dataSearch={genderNameSearch(item?.id)}>{item.type}</Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            {standardWorkdayUseWatch  &&
                                                                (standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "OTHER" ||
                                                                    standardWorkdayUseWatch[0]?.calculation?.toUpperCase() === "SUB_HALF_N_DAY" ) && <Col
                                                                xxl={{span: 3}}
                                                                xl={{span: 3}}
                                                                lg={{span: 3}}
                                                            >
                                                                <Form.Item
                                                                    {...field}
                                                                    name={[field.name, "value"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: t("formulaTitle.valueRequire")
                                                                        }
                                                                    ]}
                                                                >
                                                                    {/*<InputNumber*/}
                                                                    {/*    min={1}*/}
                                                                    {/*    max={26}*/}
                                                                    {/*    placeholder={t("formulaPlaceholder.value")}*/}
                                                                    {/*    style={{width: "100%"}}*/}
                                                                    {/*/>*/}

                                                                    <InputDecimal
                                                                        setFieldValue={(value) => {
                                                                            form.setFieldValue(['standardWorkdays', field.name, 'value'], value);
                                                                        }}
                                                                    />

                                                                </Form.Item>
                                                            </Col>}

                                                            {/*<Col*/}
                                                            {/*    xxl={{span: 6}}*/}
                                                            {/*    xl={{span: 6}}*/}
                                                            {/*    lg={{span: 6}}*/}
                                                            {/*>*/}
                                                            {/*    <Form.Item*/}
                                                            {/*        {...field}*/}
                                                            {/*        name={[field.name, "departmentIds"]}*/}
                                                            {/*    >*/}
                                                            {/*        <DG_TreeSelect_Department*/}
                                                            {/*            {...tProps}*/}
                                                            {/*            treeCheckable={"true"}*/}
                                                            {/*            showCheckedStrategy={TreeSelect.SHOW_ALL}*/}
                                                            {/*            popupMatchSelectWidth={450}*/}
                                                            {/*            placeholder={t("formulaPlaceholder.department")}*/}
                                                            {/*        />*/}
                                                            {/*    </Form.Item>*/}
                                                            {/*</Col>*/}

                                                            {/*<Col*/}
                                                            {/*    xxl={{span: 6}}*/}
                                                            {/*    xl={{span: 6}}*/}
                                                            {/*    lg={{span: 6}}*/}
                                                            {/*>*/}
                                                            {/*    <Form.Item*/}
                                                            {/*        {...field}*/}
                                                            {/*        name={[field.name, "jobPositionIds"]}*/}
                                                            {/*    >*/}

                                                            {/*        <SelectAllJobPosition*/}
                                                            {/*            filterOption={filterOption}*/}
                                                            {/*            popupMatchSelectWidth={300}*/}
                                                            {/*        />*/}

                                                            {/*    </Form.Item>*/}
                                                            {/*</Col>*/}

                                                            {field.name > 0 && <Col xxl={{span: 1}} xl={{span: 1}}
                                                                  lg={{span: 1}}>
                                                                <CloseOutlined
                                                                    style={{marginTop: 8}}
                                                                    onClick={() => {
                                                                        deleteStandard(field.name)
                                                                        remove(field.name)
                                                                    }}/>
                                                            </Col>}
                                                        </Row>
                                                    ))}

                                                {/*<Form.Item>*/}
                                                {/*    <PlusCircleOutlined*/}
                                                {/*        onClick={() => {*/}
                                                {/*            addStandard()*/}
                                                {/*            add()*/}
                                                {/*        }}*/}
                                                {/*        style={{fontSize: 25}}/>*/}
                                                {/*</Form.Item>*/}

                                            </>
                                        )
                                    }
                                </Form.List>
                            </Panel>
                        </Collapse>
                    </Form.Item>

                    <Form.Item
                        name={'note'}
                        label={t("formulaTitle.note")}
                        style={{width: 800}}
                    >
                        <TextArea
                            placeholder={t("formulaPlaceholder.note")}
                            row={4}
                        />
                    </Form.Item>

                    <Form.Item
                        name={'date'}
                        label={t("formulaTitle.automaticDate")}
                        initialValue={dayjs(Date())}
                        style={{width: 500}}
                        tooltip={<div>
                            <div>{t("formulaPlaceholder.informationDate0")}</div>
                            <div>{t("formulaPlaceholder.informationDate1")}</div>
                        </div>}
                    >
                        <DG_DatePicker
                            style={{ width : "50%" }}
                            picker="month"
                            format={dateFormat}
                            placeholder={"MM/YYYY"}
                        />
                    </Form.Item>
                </div>

            </DG_Form>
        </>
    )
}

export default TimesheetFormula